"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganisationModel = void 0;
var OrganisationModel = /** @class */ (function () {
    function OrganisationModel(id, name, featureAnalytics, stopServingFlags, persistTraitData) {
        this.id = id;
        this.name = name;
        this.featureAnalytics = featureAnalytics;
        this.stopServingFlags = stopServingFlags;
        this.persistTraitData = persistTraitData;
    }
    Object.defineProperty(OrganisationModel.prototype, "uniqueSlug", {
        get: function () {
            return this.id.toString() + '-' + this.name;
        },
        enumerable: false,
        configurable: true
    });
    return OrganisationModel;
}());
exports.OrganisationModel = OrganisationModel;
